/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivateLayoutRouteImport } from './routes/_private/layout'
import { Route as GuestLayoutRouteImport } from './routes/_guest/layout'
import { Route as PrivatePageRouteImport } from './routes/_private/page'
import { Route as PrivateSplatRouteImport } from './routes/_private/$'
import { Route as PrivatePromisLayoutRouteImport } from './routes/_private/promis/layout'
import { Route as PrivateProfilesLayoutRouteImport } from './routes/_private/profiles/layout'
import { Route as PrivateProductsLayoutRouteImport } from './routes/_private/products/layout'
import { Route as PrivateNotificationAnalyticsLayoutRouteImport } from './routes/_private/notification-analytics/layout'
import { Route as PrivateIntegrationsLayoutRouteImport } from './routes/_private/integrations/layout'
import { Route as PrivateAdminsLayoutRouteImport } from './routes/_private/admins/layout'
import { Route as PrivatePromisPageRouteImport } from './routes/_private/promis/page'
import { Route as PrivateProfilesPageRouteImport } from './routes/_private/profiles/page'
import { Route as PrivateProductsPageRouteImport } from './routes/_private/products/page'
import { Route as PrivateNotificationAnalyticsPageRouteImport } from './routes/_private/notification-analytics/page'
import { Route as PrivateIntegrationsPageRouteImport } from './routes/_private/integrations/page'
import { Route as PrivateAdminsPageRouteImport } from './routes/_private/admins/page'
import { Route as GuestSetPasswordPageRouteImport } from './routes/_guest/set-password.page'
import { Route as GuestResetPasswordPageRouteImport } from './routes/_guest/reset-password.page'
import { Route as GuestLoginPageRouteImport } from './routes/_guest/login.page'
import { Route as GuestForgotPasswordPageRouteImport } from './routes/_guest/forgot-password.page'
import { Route as PrivateProfilesIdLayoutRouteImport } from './routes/_private/profiles/$id/layout'
import { Route as PrivateIntegrationsPersonifyLayoutRouteImport } from './routes/_private/integrations/personify/layout'
import { Route as PrivateIntegrationsOpenAiLayoutRouteImport } from './routes/_private/integrations/open-ai/layout'
import { Route as PrivateIntegrationsBayesiaLayoutRouteImport } from './routes/_private/integrations/bayesia/layout'
import { Route as PrivatePromisSymptomCodePageRouteImport } from './routes/_private/promis/$symptom-code.page'
import { Route as PrivateProfilesIdPageRouteImport } from './routes/_private/profiles/$id/page'
import { Route as PrivateNotificationAnalyticsEmailTypePageRouteImport } from './routes/_private/notification-analytics/$email-type.page'
import { Route as PrivateIntegrationsPersonifyPageRouteImport } from './routes/_private/integrations/personify/page'
import { Route as PrivateIntegrationsOpenAiPageRouteImport } from './routes/_private/integrations/open-ai/page'
import { Route as PrivateIntegrationsBayesiaPageRouteImport } from './routes/_private/integrations/bayesia/page'
import { Route as PrivateAdminsIdPageRouteImport } from './routes/_private/admins/$id.page'
import { Route as PrivateProfilesIdSurveysPageRouteImport } from './routes/_private/profiles/$id/surveys.page'
import { Route as PrivateProfilesIdMessagesPageRouteImport } from './routes/_private/profiles/$id/messages.page'
import { Route as PrivateProfilesIdEmailsPageRouteImport } from './routes/_private/profiles/$id/emails.page'
import { Route as PrivateProfilesIdDetailPageRouteImport } from './routes/_private/profiles/$id/detail.page'
import { Route as PrivateProfilesIdCareplansPageRouteImport } from './routes/_private/profiles/$id/careplans.page'
import { Route as PrivateIntegrationsPersonifyRewardsPageRouteImport } from './routes/_private/integrations/personify/rewards.page'
import { Route as PrivateIntegrationsPersonifyOverviewPageRouteImport } from './routes/_private/integrations/personify/overview.page'
import { Route as PrivateIntegrationsPersonifyIdentitiesPageRouteImport } from './routes/_private/integrations/personify/identities/page'
import { Route as PrivateIntegrationsPersonifyEventsPageRouteImport } from './routes/_private/integrations/personify/events.page'
import { Route as PrivateIntegrationsOpenAiPromptsPageRouteImport } from './routes/_private/integrations/open-ai/prompts/page'
import { Route as PrivateIntegrationsBayesiaModelsPageRouteImport } from './routes/_private/integrations/bayesia/models/page'
import { Route as PrivateIntegrationsBayesiaInferencesPageRouteImport } from './routes/_private/integrations/bayesia/inferences/page'
import { Route as PrivateIntegrationsPersonifyIdentitiesIdPageRouteImport } from './routes/_private/integrations/personify/identities/$id.page'
import { Route as PrivateIntegrationsOpenAiPromptsIdPageRouteImport } from './routes/_private/integrations/open-ai/prompts/$id.page'
import { Route as PrivateIntegrationsBayesiaInferencesIdPageRouteImport } from './routes/_private/integrations/bayesia/inferences/$id.page'

const PrivateLayoutRoute = PrivateLayoutRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestLayoutRoute = GuestLayoutRouteImport.update({
  id: '/_guest',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivatePageRoute = PrivatePageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivateSplatRoute = PrivateSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivatePromisLayoutRoute = PrivatePromisLayoutRouteImport.update({
  id: '/promis',
  path: '/promis',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivateProfilesLayoutRoute = PrivateProfilesLayoutRouteImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivateProductsLayoutRoute = PrivateProductsLayoutRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivateNotificationAnalyticsLayoutRoute =
  PrivateNotificationAnalyticsLayoutRouteImport.update({
    id: '/notification-analytics',
    path: '/notification-analytics',
    getParentRoute: () => PrivateLayoutRoute,
  } as any)
const PrivateIntegrationsLayoutRoute =
  PrivateIntegrationsLayoutRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => PrivateLayoutRoute,
  } as any)
const PrivateAdminsLayoutRoute = PrivateAdminsLayoutRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivatePromisPageRoute = PrivatePromisPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivatePromisLayoutRoute,
} as any)
const PrivateProfilesPageRoute = PrivateProfilesPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateProfilesLayoutRoute,
} as any)
const PrivateProductsPageRoute = PrivateProductsPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateProductsLayoutRoute,
} as any)
const PrivateNotificationAnalyticsPageRoute =
  PrivateNotificationAnalyticsPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateNotificationAnalyticsLayoutRoute,
  } as any)
const PrivateIntegrationsPageRoute = PrivateIntegrationsPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateIntegrationsLayoutRoute,
} as any)
const PrivateAdminsPageRoute = PrivateAdminsPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateAdminsLayoutRoute,
} as any)
const GuestSetPasswordPageRoute = GuestSetPasswordPageRouteImport.update({
  id: '/set-password/',
  path: '/set-password/',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const GuestResetPasswordPageRoute = GuestResetPasswordPageRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const GuestLoginPageRoute = GuestLoginPageRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const GuestForgotPasswordPageRoute = GuestForgotPasswordPageRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const PrivateProfilesIdLayoutRoute = PrivateProfilesIdLayoutRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PrivateProfilesLayoutRoute,
} as any)
const PrivateIntegrationsPersonifyLayoutRoute =
  PrivateIntegrationsPersonifyLayoutRouteImport.update({
    id: '/personify',
    path: '/personify',
    getParentRoute: () => PrivateIntegrationsLayoutRoute,
  } as any)
const PrivateIntegrationsOpenAiLayoutRoute =
  PrivateIntegrationsOpenAiLayoutRouteImport.update({
    id: '/open-ai',
    path: '/open-ai',
    getParentRoute: () => PrivateIntegrationsLayoutRoute,
  } as any)
const PrivateIntegrationsBayesiaLayoutRoute =
  PrivateIntegrationsBayesiaLayoutRouteImport.update({
    id: '/bayesia',
    path: '/bayesia',
    getParentRoute: () => PrivateIntegrationsLayoutRoute,
  } as any)
const PrivatePromisSymptomCodePageRoute =
  PrivatePromisSymptomCodePageRouteImport.update({
    id: '/$symptom-code/',
    path: '/$symptom-code/',
    getParentRoute: () => PrivatePromisLayoutRoute,
  } as any)
const PrivateProfilesIdPageRoute = PrivateProfilesIdPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateProfilesIdLayoutRoute,
} as any)
const PrivateNotificationAnalyticsEmailTypePageRoute =
  PrivateNotificationAnalyticsEmailTypePageRouteImport.update({
    id: '/$email-type/',
    path: '/$email-type/',
    getParentRoute: () => PrivateNotificationAnalyticsLayoutRoute,
  } as any)
const PrivateIntegrationsPersonifyPageRoute =
  PrivateIntegrationsPersonifyPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateIntegrationsPersonifyLayoutRoute,
  } as any)
const PrivateIntegrationsOpenAiPageRoute =
  PrivateIntegrationsOpenAiPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateIntegrationsOpenAiLayoutRoute,
  } as any)
const PrivateIntegrationsBayesiaPageRoute =
  PrivateIntegrationsBayesiaPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateIntegrationsBayesiaLayoutRoute,
  } as any)
const PrivateAdminsIdPageRoute = PrivateAdminsIdPageRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => PrivateAdminsLayoutRoute,
} as any)
const PrivateProfilesIdSurveysPageRoute =
  PrivateProfilesIdSurveysPageRouteImport.update({
    id: '/surveys/',
    path: '/surveys/',
    getParentRoute: () => PrivateProfilesIdLayoutRoute,
  } as any)
const PrivateProfilesIdMessagesPageRoute =
  PrivateProfilesIdMessagesPageRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => PrivateProfilesIdLayoutRoute,
  } as any)
const PrivateProfilesIdEmailsPageRoute =
  PrivateProfilesIdEmailsPageRouteImport.update({
    id: '/emails/',
    path: '/emails/',
    getParentRoute: () => PrivateProfilesIdLayoutRoute,
  } as any)
const PrivateProfilesIdDetailPageRoute =
  PrivateProfilesIdDetailPageRouteImport.update({
    id: '/detail/',
    path: '/detail/',
    getParentRoute: () => PrivateProfilesIdLayoutRoute,
  } as any)
const PrivateProfilesIdCareplansPageRoute =
  PrivateProfilesIdCareplansPageRouteImport.update({
    id: '/careplans/',
    path: '/careplans/',
    getParentRoute: () => PrivateProfilesIdLayoutRoute,
  } as any)
const PrivateIntegrationsPersonifyRewardsPageRoute =
  PrivateIntegrationsPersonifyRewardsPageRouteImport.update({
    id: '/rewards/',
    path: '/rewards/',
    getParentRoute: () => PrivateIntegrationsPersonifyLayoutRoute,
  } as any)
const PrivateIntegrationsPersonifyOverviewPageRoute =
  PrivateIntegrationsPersonifyOverviewPageRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => PrivateIntegrationsPersonifyLayoutRoute,
  } as any)
const PrivateIntegrationsPersonifyIdentitiesPageRoute =
  PrivateIntegrationsPersonifyIdentitiesPageRouteImport.update({
    id: '/identities/',
    path: '/identities/',
    getParentRoute: () => PrivateIntegrationsPersonifyLayoutRoute,
  } as any)
const PrivateIntegrationsPersonifyEventsPageRoute =
  PrivateIntegrationsPersonifyEventsPageRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => PrivateIntegrationsPersonifyLayoutRoute,
  } as any)
const PrivateIntegrationsOpenAiPromptsPageRoute =
  PrivateIntegrationsOpenAiPromptsPageRouteImport.update({
    id: '/prompts/',
    path: '/prompts/',
    getParentRoute: () => PrivateIntegrationsOpenAiLayoutRoute,
  } as any)
const PrivateIntegrationsBayesiaModelsPageRoute =
  PrivateIntegrationsBayesiaModelsPageRouteImport.update({
    id: '/models/',
    path: '/models/',
    getParentRoute: () => PrivateIntegrationsBayesiaLayoutRoute,
  } as any)
const PrivateIntegrationsBayesiaInferencesPageRoute =
  PrivateIntegrationsBayesiaInferencesPageRouteImport.update({
    id: '/inferences/',
    path: '/inferences/',
    getParentRoute: () => PrivateIntegrationsBayesiaLayoutRoute,
  } as any)
const PrivateIntegrationsPersonifyIdentitiesIdPageRoute =
  PrivateIntegrationsPersonifyIdentitiesIdPageRouteImport.update({
    id: '/identities/$id/',
    path: '/identities/$id/',
    getParentRoute: () => PrivateIntegrationsPersonifyLayoutRoute,
  } as any)
const PrivateIntegrationsOpenAiPromptsIdPageRoute =
  PrivateIntegrationsOpenAiPromptsIdPageRouteImport.update({
    id: '/prompts/$id/',
    path: '/prompts/$id/',
    getParentRoute: () => PrivateIntegrationsOpenAiLayoutRoute,
  } as any)
const PrivateIntegrationsBayesiaInferencesIdPageRoute =
  PrivateIntegrationsBayesiaInferencesIdPageRouteImport.update({
    id: '/inferences/$id/',
    path: '/inferences/$id/',
    getParentRoute: () => PrivateIntegrationsBayesiaLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/admins': typeof PrivateAdminsLayoutRouteWithChildren
  '/integrations': typeof PrivateIntegrationsLayoutRouteWithChildren
  '/notification-analytics': typeof PrivateNotificationAnalyticsLayoutRouteWithChildren
  '/products': typeof PrivateProductsLayoutRouteWithChildren
  '/profiles': typeof PrivateProfilesLayoutRouteWithChildren
  '/promis': typeof PrivatePromisLayoutRouteWithChildren
  '/$': typeof PrivateSplatRoute
  '/': typeof PrivatePageRoute
  '/integrations/bayesia': typeof PrivateIntegrationsBayesiaLayoutRouteWithChildren
  '/integrations/open-ai': typeof PrivateIntegrationsOpenAiLayoutRouteWithChildren
  '/integrations/personify': typeof PrivateIntegrationsPersonifyLayoutRouteWithChildren
  '/profiles/$id': typeof PrivateProfilesIdLayoutRouteWithChildren
  '/forgot-password': typeof GuestForgotPasswordPageRoute
  '/login': typeof GuestLoginPageRoute
  '/reset-password': typeof GuestResetPasswordPageRoute
  '/set-password': typeof GuestSetPasswordPageRoute
  '/admins/': typeof PrivateAdminsPageRoute
  '/integrations/': typeof PrivateIntegrationsPageRoute
  '/notification-analytics/': typeof PrivateNotificationAnalyticsPageRoute
  '/products/': typeof PrivateProductsPageRoute
  '/profiles/': typeof PrivateProfilesPageRoute
  '/promis/': typeof PrivatePromisPageRoute
  '/admins/$id': typeof PrivateAdminsIdPageRoute
  '/integrations/bayesia/': typeof PrivateIntegrationsBayesiaPageRoute
  '/integrations/open-ai/': typeof PrivateIntegrationsOpenAiPageRoute
  '/integrations/personify/': typeof PrivateIntegrationsPersonifyPageRoute
  '/notification-analytics/$email-type': typeof PrivateNotificationAnalyticsEmailTypePageRoute
  '/profiles/$id/': typeof PrivateProfilesIdPageRoute
  '/promis/$symptom-code': typeof PrivatePromisSymptomCodePageRoute
  '/integrations/bayesia/inferences': typeof PrivateIntegrationsBayesiaInferencesPageRoute
  '/integrations/bayesia/models': typeof PrivateIntegrationsBayesiaModelsPageRoute
  '/integrations/open-ai/prompts': typeof PrivateIntegrationsOpenAiPromptsPageRoute
  '/integrations/personify/events': typeof PrivateIntegrationsPersonifyEventsPageRoute
  '/integrations/personify/identities': typeof PrivateIntegrationsPersonifyIdentitiesPageRoute
  '/integrations/personify/overview': typeof PrivateIntegrationsPersonifyOverviewPageRoute
  '/integrations/personify/rewards': typeof PrivateIntegrationsPersonifyRewardsPageRoute
  '/profiles/$id/careplans': typeof PrivateProfilesIdCareplansPageRoute
  '/profiles/$id/detail': typeof PrivateProfilesIdDetailPageRoute
  '/profiles/$id/emails': typeof PrivateProfilesIdEmailsPageRoute
  '/profiles/$id/messages': typeof PrivateProfilesIdMessagesPageRoute
  '/profiles/$id/surveys': typeof PrivateProfilesIdSurveysPageRoute
  '/integrations/bayesia/inferences/$id': typeof PrivateIntegrationsBayesiaInferencesIdPageRoute
  '/integrations/open-ai/prompts/$id': typeof PrivateIntegrationsOpenAiPromptsIdPageRoute
  '/integrations/personify/identities/$id': typeof PrivateIntegrationsPersonifyIdentitiesIdPageRoute
}
export interface FileRoutesByTo {
  '/$': typeof PrivateSplatRoute
  '/': typeof PrivatePageRoute
  '/forgot-password': typeof GuestForgotPasswordPageRoute
  '/login': typeof GuestLoginPageRoute
  '/reset-password': typeof GuestResetPasswordPageRoute
  '/set-password': typeof GuestSetPasswordPageRoute
  '/admins': typeof PrivateAdminsPageRoute
  '/integrations': typeof PrivateIntegrationsPageRoute
  '/notification-analytics': typeof PrivateNotificationAnalyticsPageRoute
  '/products': typeof PrivateProductsPageRoute
  '/profiles': typeof PrivateProfilesPageRoute
  '/promis': typeof PrivatePromisPageRoute
  '/admins/$id': typeof PrivateAdminsIdPageRoute
  '/integrations/bayesia': typeof PrivateIntegrationsBayesiaPageRoute
  '/integrations/open-ai': typeof PrivateIntegrationsOpenAiPageRoute
  '/integrations/personify': typeof PrivateIntegrationsPersonifyPageRoute
  '/notification-analytics/$email-type': typeof PrivateNotificationAnalyticsEmailTypePageRoute
  '/profiles/$id': typeof PrivateProfilesIdPageRoute
  '/promis/$symptom-code': typeof PrivatePromisSymptomCodePageRoute
  '/integrations/bayesia/inferences': typeof PrivateIntegrationsBayesiaInferencesPageRoute
  '/integrations/bayesia/models': typeof PrivateIntegrationsBayesiaModelsPageRoute
  '/integrations/open-ai/prompts': typeof PrivateIntegrationsOpenAiPromptsPageRoute
  '/integrations/personify/events': typeof PrivateIntegrationsPersonifyEventsPageRoute
  '/integrations/personify/identities': typeof PrivateIntegrationsPersonifyIdentitiesPageRoute
  '/integrations/personify/overview': typeof PrivateIntegrationsPersonifyOverviewPageRoute
  '/integrations/personify/rewards': typeof PrivateIntegrationsPersonifyRewardsPageRoute
  '/profiles/$id/careplans': typeof PrivateProfilesIdCareplansPageRoute
  '/profiles/$id/detail': typeof PrivateProfilesIdDetailPageRoute
  '/profiles/$id/emails': typeof PrivateProfilesIdEmailsPageRoute
  '/profiles/$id/messages': typeof PrivateProfilesIdMessagesPageRoute
  '/profiles/$id/surveys': typeof PrivateProfilesIdSurveysPageRoute
  '/integrations/bayesia/inferences/$id': typeof PrivateIntegrationsBayesiaInferencesIdPageRoute
  '/integrations/open-ai/prompts/$id': typeof PrivateIntegrationsOpenAiPromptsIdPageRoute
  '/integrations/personify/identities/$id': typeof PrivateIntegrationsPersonifyIdentitiesIdPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_guest': typeof GuestLayoutRouteWithChildren
  '/_private': typeof PrivateLayoutRouteWithChildren
  '/_private/admins': typeof PrivateAdminsLayoutRouteWithChildren
  '/_private/integrations': typeof PrivateIntegrationsLayoutRouteWithChildren
  '/_private/notification-analytics': typeof PrivateNotificationAnalyticsLayoutRouteWithChildren
  '/_private/products': typeof PrivateProductsLayoutRouteWithChildren
  '/_private/profiles': typeof PrivateProfilesLayoutRouteWithChildren
  '/_private/promis': typeof PrivatePromisLayoutRouteWithChildren
  '/_private/$': typeof PrivateSplatRoute
  '/_private/': typeof PrivatePageRoute
  '/_private/integrations/bayesia': typeof PrivateIntegrationsBayesiaLayoutRouteWithChildren
  '/_private/integrations/open-ai': typeof PrivateIntegrationsOpenAiLayoutRouteWithChildren
  '/_private/integrations/personify': typeof PrivateIntegrationsPersonifyLayoutRouteWithChildren
  '/_private/profiles/$id': typeof PrivateProfilesIdLayoutRouteWithChildren
  '/_guest/forgot-password/': typeof GuestForgotPasswordPageRoute
  '/_guest/login/': typeof GuestLoginPageRoute
  '/_guest/reset-password/': typeof GuestResetPasswordPageRoute
  '/_guest/set-password/': typeof GuestSetPasswordPageRoute
  '/_private/admins/': typeof PrivateAdminsPageRoute
  '/_private/integrations/': typeof PrivateIntegrationsPageRoute
  '/_private/notification-analytics/': typeof PrivateNotificationAnalyticsPageRoute
  '/_private/products/': typeof PrivateProductsPageRoute
  '/_private/profiles/': typeof PrivateProfilesPageRoute
  '/_private/promis/': typeof PrivatePromisPageRoute
  '/_private/admins/$id/': typeof PrivateAdminsIdPageRoute
  '/_private/integrations/bayesia/': typeof PrivateIntegrationsBayesiaPageRoute
  '/_private/integrations/open-ai/': typeof PrivateIntegrationsOpenAiPageRoute
  '/_private/integrations/personify/': typeof PrivateIntegrationsPersonifyPageRoute
  '/_private/notification-analytics/$email-type/': typeof PrivateNotificationAnalyticsEmailTypePageRoute
  '/_private/profiles/$id/': typeof PrivateProfilesIdPageRoute
  '/_private/promis/$symptom-code/': typeof PrivatePromisSymptomCodePageRoute
  '/_private/integrations/bayesia/inferences/': typeof PrivateIntegrationsBayesiaInferencesPageRoute
  '/_private/integrations/bayesia/models/': typeof PrivateIntegrationsBayesiaModelsPageRoute
  '/_private/integrations/open-ai/prompts/': typeof PrivateIntegrationsOpenAiPromptsPageRoute
  '/_private/integrations/personify/events/': typeof PrivateIntegrationsPersonifyEventsPageRoute
  '/_private/integrations/personify/identities/': typeof PrivateIntegrationsPersonifyIdentitiesPageRoute
  '/_private/integrations/personify/overview/': typeof PrivateIntegrationsPersonifyOverviewPageRoute
  '/_private/integrations/personify/rewards/': typeof PrivateIntegrationsPersonifyRewardsPageRoute
  '/_private/profiles/$id/careplans/': typeof PrivateProfilesIdCareplansPageRoute
  '/_private/profiles/$id/detail/': typeof PrivateProfilesIdDetailPageRoute
  '/_private/profiles/$id/emails/': typeof PrivateProfilesIdEmailsPageRoute
  '/_private/profiles/$id/messages/': typeof PrivateProfilesIdMessagesPageRoute
  '/_private/profiles/$id/surveys/': typeof PrivateProfilesIdSurveysPageRoute
  '/_private/integrations/bayesia/inferences/$id/': typeof PrivateIntegrationsBayesiaInferencesIdPageRoute
  '/_private/integrations/open-ai/prompts/$id/': typeof PrivateIntegrationsOpenAiPromptsIdPageRoute
  '/_private/integrations/personify/identities/$id/': typeof PrivateIntegrationsPersonifyIdentitiesIdPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admins'
    | '/integrations'
    | '/notification-analytics'
    | '/products'
    | '/profiles'
    | '/promis'
    | '/$'
    | '/'
    | '/integrations/bayesia'
    | '/integrations/open-ai'
    | '/integrations/personify'
    | '/profiles/$id'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/admins/'
    | '/integrations/'
    | '/notification-analytics/'
    | '/products/'
    | '/profiles/'
    | '/promis/'
    | '/admins/$id'
    | '/integrations/bayesia/'
    | '/integrations/open-ai/'
    | '/integrations/personify/'
    | '/notification-analytics/$email-type'
    | '/profiles/$id/'
    | '/promis/$symptom-code'
    | '/integrations/bayesia/inferences'
    | '/integrations/bayesia/models'
    | '/integrations/open-ai/prompts'
    | '/integrations/personify/events'
    | '/integrations/personify/identities'
    | '/integrations/personify/overview'
    | '/integrations/personify/rewards'
    | '/profiles/$id/careplans'
    | '/profiles/$id/detail'
    | '/profiles/$id/emails'
    | '/profiles/$id/messages'
    | '/profiles/$id/surveys'
    | '/integrations/bayesia/inferences/$id'
    | '/integrations/open-ai/prompts/$id'
    | '/integrations/personify/identities/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/admins'
    | '/integrations'
    | '/notification-analytics'
    | '/products'
    | '/profiles'
    | '/promis'
    | '/admins/$id'
    | '/integrations/bayesia'
    | '/integrations/open-ai'
    | '/integrations/personify'
    | '/notification-analytics/$email-type'
    | '/profiles/$id'
    | '/promis/$symptom-code'
    | '/integrations/bayesia/inferences'
    | '/integrations/bayesia/models'
    | '/integrations/open-ai/prompts'
    | '/integrations/personify/events'
    | '/integrations/personify/identities'
    | '/integrations/personify/overview'
    | '/integrations/personify/rewards'
    | '/profiles/$id/careplans'
    | '/profiles/$id/detail'
    | '/profiles/$id/emails'
    | '/profiles/$id/messages'
    | '/profiles/$id/surveys'
    | '/integrations/bayesia/inferences/$id'
    | '/integrations/open-ai/prompts/$id'
    | '/integrations/personify/identities/$id'
  id:
    | '__root__'
    | '/_guest'
    | '/_private'
    | '/_private/admins'
    | '/_private/integrations'
    | '/_private/notification-analytics'
    | '/_private/products'
    | '/_private/profiles'
    | '/_private/promis'
    | '/_private/$'
    | '/_private/'
    | '/_private/integrations/bayesia'
    | '/_private/integrations/open-ai'
    | '/_private/integrations/personify'
    | '/_private/profiles/$id'
    | '/_guest/forgot-password/'
    | '/_guest/login/'
    | '/_guest/reset-password/'
    | '/_guest/set-password/'
    | '/_private/admins/'
    | '/_private/integrations/'
    | '/_private/notification-analytics/'
    | '/_private/products/'
    | '/_private/profiles/'
    | '/_private/promis/'
    | '/_private/admins/$id/'
    | '/_private/integrations/bayesia/'
    | '/_private/integrations/open-ai/'
    | '/_private/integrations/personify/'
    | '/_private/notification-analytics/$email-type/'
    | '/_private/profiles/$id/'
    | '/_private/promis/$symptom-code/'
    | '/_private/integrations/bayesia/inferences/'
    | '/_private/integrations/bayesia/models/'
    | '/_private/integrations/open-ai/prompts/'
    | '/_private/integrations/personify/events/'
    | '/_private/integrations/personify/identities/'
    | '/_private/integrations/personify/overview/'
    | '/_private/integrations/personify/rewards/'
    | '/_private/profiles/$id/careplans/'
    | '/_private/profiles/$id/detail/'
    | '/_private/profiles/$id/emails/'
    | '/_private/profiles/$id/messages/'
    | '/_private/profiles/$id/surveys/'
    | '/_private/integrations/bayesia/inferences/$id/'
    | '/_private/integrations/open-ai/prompts/$id/'
    | '/_private/integrations/personify/identities/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  GuestLayoutRoute: typeof GuestLayoutRouteWithChildren
  PrivateLayoutRoute: typeof PrivateLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof GuestLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/': {
      id: '/_private/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PrivatePageRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/$': {
      id: '/_private/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof PrivateSplatRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/promis': {
      id: '/_private/promis'
      path: '/promis'
      fullPath: '/promis'
      preLoaderRoute: typeof PrivatePromisLayoutRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/profiles': {
      id: '/_private/profiles'
      path: '/profiles'
      fullPath: '/profiles'
      preLoaderRoute: typeof PrivateProfilesLayoutRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/products': {
      id: '/_private/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof PrivateProductsLayoutRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/notification-analytics': {
      id: '/_private/notification-analytics'
      path: '/notification-analytics'
      fullPath: '/notification-analytics'
      preLoaderRoute: typeof PrivateNotificationAnalyticsLayoutRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/integrations': {
      id: '/_private/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof PrivateIntegrationsLayoutRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/admins': {
      id: '/_private/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof PrivateAdminsLayoutRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/promis/': {
      id: '/_private/promis/'
      path: '/'
      fullPath: '/promis/'
      preLoaderRoute: typeof PrivatePromisPageRouteImport
      parentRoute: typeof PrivatePromisLayoutRoute
    }
    '/_private/profiles/': {
      id: '/_private/profiles/'
      path: '/'
      fullPath: '/profiles/'
      preLoaderRoute: typeof PrivateProfilesPageRouteImport
      parentRoute: typeof PrivateProfilesLayoutRoute
    }
    '/_private/products/': {
      id: '/_private/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof PrivateProductsPageRouteImport
      parentRoute: typeof PrivateProductsLayoutRoute
    }
    '/_private/notification-analytics/': {
      id: '/_private/notification-analytics/'
      path: '/'
      fullPath: '/notification-analytics/'
      preLoaderRoute: typeof PrivateNotificationAnalyticsPageRouteImport
      parentRoute: typeof PrivateNotificationAnalyticsLayoutRoute
    }
    '/_private/integrations/': {
      id: '/_private/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof PrivateIntegrationsPageRouteImport
      parentRoute: typeof PrivateIntegrationsLayoutRoute
    }
    '/_private/admins/': {
      id: '/_private/admins/'
      path: '/'
      fullPath: '/admins/'
      preLoaderRoute: typeof PrivateAdminsPageRouteImport
      parentRoute: typeof PrivateAdminsLayoutRoute
    }
    '/_guest/set-password/': {
      id: '/_guest/set-password/'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof GuestSetPasswordPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/reset-password/': {
      id: '/_guest/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof GuestResetPasswordPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/login/': {
      id: '/_guest/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof GuestLoginPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/forgot-password/': {
      id: '/_guest/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof GuestForgotPasswordPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_private/profiles/$id': {
      id: '/_private/profiles/$id'
      path: '/$id'
      fullPath: '/profiles/$id'
      preLoaderRoute: typeof PrivateProfilesIdLayoutRouteImport
      parentRoute: typeof PrivateProfilesLayoutRoute
    }
    '/_private/integrations/personify': {
      id: '/_private/integrations/personify'
      path: '/personify'
      fullPath: '/integrations/personify'
      preLoaderRoute: typeof PrivateIntegrationsPersonifyLayoutRouteImport
      parentRoute: typeof PrivateIntegrationsLayoutRoute
    }
    '/_private/integrations/open-ai': {
      id: '/_private/integrations/open-ai'
      path: '/open-ai'
      fullPath: '/integrations/open-ai'
      preLoaderRoute: typeof PrivateIntegrationsOpenAiLayoutRouteImport
      parentRoute: typeof PrivateIntegrationsLayoutRoute
    }
    '/_private/integrations/bayesia': {
      id: '/_private/integrations/bayesia'
      path: '/bayesia'
      fullPath: '/integrations/bayesia'
      preLoaderRoute: typeof PrivateIntegrationsBayesiaLayoutRouteImport
      parentRoute: typeof PrivateIntegrationsLayoutRoute
    }
    '/_private/promis/$symptom-code/': {
      id: '/_private/promis/$symptom-code/'
      path: '/$symptom-code'
      fullPath: '/promis/$symptom-code'
      preLoaderRoute: typeof PrivatePromisSymptomCodePageRouteImport
      parentRoute: typeof PrivatePromisLayoutRoute
    }
    '/_private/profiles/$id/': {
      id: '/_private/profiles/$id/'
      path: '/'
      fullPath: '/profiles/$id/'
      preLoaderRoute: typeof PrivateProfilesIdPageRouteImport
      parentRoute: typeof PrivateProfilesIdLayoutRoute
    }
    '/_private/notification-analytics/$email-type/': {
      id: '/_private/notification-analytics/$email-type/'
      path: '/$email-type'
      fullPath: '/notification-analytics/$email-type'
      preLoaderRoute: typeof PrivateNotificationAnalyticsEmailTypePageRouteImport
      parentRoute: typeof PrivateNotificationAnalyticsLayoutRoute
    }
    '/_private/integrations/personify/': {
      id: '/_private/integrations/personify/'
      path: '/'
      fullPath: '/integrations/personify/'
      preLoaderRoute: typeof PrivateIntegrationsPersonifyPageRouteImport
      parentRoute: typeof PrivateIntegrationsPersonifyLayoutRoute
    }
    '/_private/integrations/open-ai/': {
      id: '/_private/integrations/open-ai/'
      path: '/'
      fullPath: '/integrations/open-ai/'
      preLoaderRoute: typeof PrivateIntegrationsOpenAiPageRouteImport
      parentRoute: typeof PrivateIntegrationsOpenAiLayoutRoute
    }
    '/_private/integrations/bayesia/': {
      id: '/_private/integrations/bayesia/'
      path: '/'
      fullPath: '/integrations/bayesia/'
      preLoaderRoute: typeof PrivateIntegrationsBayesiaPageRouteImport
      parentRoute: typeof PrivateIntegrationsBayesiaLayoutRoute
    }
    '/_private/admins/$id/': {
      id: '/_private/admins/$id/'
      path: '/$id'
      fullPath: '/admins/$id'
      preLoaderRoute: typeof PrivateAdminsIdPageRouteImport
      parentRoute: typeof PrivateAdminsLayoutRoute
    }
    '/_private/profiles/$id/surveys/': {
      id: '/_private/profiles/$id/surveys/'
      path: '/surveys'
      fullPath: '/profiles/$id/surveys'
      preLoaderRoute: typeof PrivateProfilesIdSurveysPageRouteImport
      parentRoute: typeof PrivateProfilesIdLayoutRoute
    }
    '/_private/profiles/$id/messages/': {
      id: '/_private/profiles/$id/messages/'
      path: '/messages'
      fullPath: '/profiles/$id/messages'
      preLoaderRoute: typeof PrivateProfilesIdMessagesPageRouteImport
      parentRoute: typeof PrivateProfilesIdLayoutRoute
    }
    '/_private/profiles/$id/emails/': {
      id: '/_private/profiles/$id/emails/'
      path: '/emails'
      fullPath: '/profiles/$id/emails'
      preLoaderRoute: typeof PrivateProfilesIdEmailsPageRouteImport
      parentRoute: typeof PrivateProfilesIdLayoutRoute
    }
    '/_private/profiles/$id/detail/': {
      id: '/_private/profiles/$id/detail/'
      path: '/detail'
      fullPath: '/profiles/$id/detail'
      preLoaderRoute: typeof PrivateProfilesIdDetailPageRouteImport
      parentRoute: typeof PrivateProfilesIdLayoutRoute
    }
    '/_private/profiles/$id/careplans/': {
      id: '/_private/profiles/$id/careplans/'
      path: '/careplans'
      fullPath: '/profiles/$id/careplans'
      preLoaderRoute: typeof PrivateProfilesIdCareplansPageRouteImport
      parentRoute: typeof PrivateProfilesIdLayoutRoute
    }
    '/_private/integrations/personify/rewards/': {
      id: '/_private/integrations/personify/rewards/'
      path: '/rewards'
      fullPath: '/integrations/personify/rewards'
      preLoaderRoute: typeof PrivateIntegrationsPersonifyRewardsPageRouteImport
      parentRoute: typeof PrivateIntegrationsPersonifyLayoutRoute
    }
    '/_private/integrations/personify/overview/': {
      id: '/_private/integrations/personify/overview/'
      path: '/overview'
      fullPath: '/integrations/personify/overview'
      preLoaderRoute: typeof PrivateIntegrationsPersonifyOverviewPageRouteImport
      parentRoute: typeof PrivateIntegrationsPersonifyLayoutRoute
    }
    '/_private/integrations/personify/identities/': {
      id: '/_private/integrations/personify/identities/'
      path: '/identities'
      fullPath: '/integrations/personify/identities'
      preLoaderRoute: typeof PrivateIntegrationsPersonifyIdentitiesPageRouteImport
      parentRoute: typeof PrivateIntegrationsPersonifyLayoutRoute
    }
    '/_private/integrations/personify/events/': {
      id: '/_private/integrations/personify/events/'
      path: '/events'
      fullPath: '/integrations/personify/events'
      preLoaderRoute: typeof PrivateIntegrationsPersonifyEventsPageRouteImport
      parentRoute: typeof PrivateIntegrationsPersonifyLayoutRoute
    }
    '/_private/integrations/open-ai/prompts/': {
      id: '/_private/integrations/open-ai/prompts/'
      path: '/prompts'
      fullPath: '/integrations/open-ai/prompts'
      preLoaderRoute: typeof PrivateIntegrationsOpenAiPromptsPageRouteImport
      parentRoute: typeof PrivateIntegrationsOpenAiLayoutRoute
    }
    '/_private/integrations/bayesia/models/': {
      id: '/_private/integrations/bayesia/models/'
      path: '/models'
      fullPath: '/integrations/bayesia/models'
      preLoaderRoute: typeof PrivateIntegrationsBayesiaModelsPageRouteImport
      parentRoute: typeof PrivateIntegrationsBayesiaLayoutRoute
    }
    '/_private/integrations/bayesia/inferences/': {
      id: '/_private/integrations/bayesia/inferences/'
      path: '/inferences'
      fullPath: '/integrations/bayesia/inferences'
      preLoaderRoute: typeof PrivateIntegrationsBayesiaInferencesPageRouteImport
      parentRoute: typeof PrivateIntegrationsBayesiaLayoutRoute
    }
    '/_private/integrations/personify/identities/$id/': {
      id: '/_private/integrations/personify/identities/$id/'
      path: '/identities/$id'
      fullPath: '/integrations/personify/identities/$id'
      preLoaderRoute: typeof PrivateIntegrationsPersonifyIdentitiesIdPageRouteImport
      parentRoute: typeof PrivateIntegrationsPersonifyLayoutRoute
    }
    '/_private/integrations/open-ai/prompts/$id/': {
      id: '/_private/integrations/open-ai/prompts/$id/'
      path: '/prompts/$id'
      fullPath: '/integrations/open-ai/prompts/$id'
      preLoaderRoute: typeof PrivateIntegrationsOpenAiPromptsIdPageRouteImport
      parentRoute: typeof PrivateIntegrationsOpenAiLayoutRoute
    }
    '/_private/integrations/bayesia/inferences/$id/': {
      id: '/_private/integrations/bayesia/inferences/$id/'
      path: '/inferences/$id'
      fullPath: '/integrations/bayesia/inferences/$id'
      preLoaderRoute: typeof PrivateIntegrationsBayesiaInferencesIdPageRouteImport
      parentRoute: typeof PrivateIntegrationsBayesiaLayoutRoute
    }
  }
}

interface GuestLayoutRouteChildren {
  GuestForgotPasswordPageRoute: typeof GuestForgotPasswordPageRoute
  GuestLoginPageRoute: typeof GuestLoginPageRoute
  GuestResetPasswordPageRoute: typeof GuestResetPasswordPageRoute
  GuestSetPasswordPageRoute: typeof GuestSetPasswordPageRoute
}

const GuestLayoutRouteChildren: GuestLayoutRouteChildren = {
  GuestForgotPasswordPageRoute: GuestForgotPasswordPageRoute,
  GuestLoginPageRoute: GuestLoginPageRoute,
  GuestResetPasswordPageRoute: GuestResetPasswordPageRoute,
  GuestSetPasswordPageRoute: GuestSetPasswordPageRoute,
}

const GuestLayoutRouteWithChildren = GuestLayoutRoute._addFileChildren(
  GuestLayoutRouteChildren,
)

interface PrivateAdminsLayoutRouteChildren {
  PrivateAdminsPageRoute: typeof PrivateAdminsPageRoute
  PrivateAdminsIdPageRoute: typeof PrivateAdminsIdPageRoute
}

const PrivateAdminsLayoutRouteChildren: PrivateAdminsLayoutRouteChildren = {
  PrivateAdminsPageRoute: PrivateAdminsPageRoute,
  PrivateAdminsIdPageRoute: PrivateAdminsIdPageRoute,
}

const PrivateAdminsLayoutRouteWithChildren =
  PrivateAdminsLayoutRoute._addFileChildren(PrivateAdminsLayoutRouteChildren)

interface PrivateIntegrationsBayesiaLayoutRouteChildren {
  PrivateIntegrationsBayesiaPageRoute: typeof PrivateIntegrationsBayesiaPageRoute
  PrivateIntegrationsBayesiaInferencesPageRoute: typeof PrivateIntegrationsBayesiaInferencesPageRoute
  PrivateIntegrationsBayesiaModelsPageRoute: typeof PrivateIntegrationsBayesiaModelsPageRoute
  PrivateIntegrationsBayesiaInferencesIdPageRoute: typeof PrivateIntegrationsBayesiaInferencesIdPageRoute
}

const PrivateIntegrationsBayesiaLayoutRouteChildren: PrivateIntegrationsBayesiaLayoutRouteChildren =
  {
    PrivateIntegrationsBayesiaPageRoute: PrivateIntegrationsBayesiaPageRoute,
    PrivateIntegrationsBayesiaInferencesPageRoute:
      PrivateIntegrationsBayesiaInferencesPageRoute,
    PrivateIntegrationsBayesiaModelsPageRoute:
      PrivateIntegrationsBayesiaModelsPageRoute,
    PrivateIntegrationsBayesiaInferencesIdPageRoute:
      PrivateIntegrationsBayesiaInferencesIdPageRoute,
  }

const PrivateIntegrationsBayesiaLayoutRouteWithChildren =
  PrivateIntegrationsBayesiaLayoutRoute._addFileChildren(
    PrivateIntegrationsBayesiaLayoutRouteChildren,
  )

interface PrivateIntegrationsOpenAiLayoutRouteChildren {
  PrivateIntegrationsOpenAiPageRoute: typeof PrivateIntegrationsOpenAiPageRoute
  PrivateIntegrationsOpenAiPromptsPageRoute: typeof PrivateIntegrationsOpenAiPromptsPageRoute
  PrivateIntegrationsOpenAiPromptsIdPageRoute: typeof PrivateIntegrationsOpenAiPromptsIdPageRoute
}

const PrivateIntegrationsOpenAiLayoutRouteChildren: PrivateIntegrationsOpenAiLayoutRouteChildren =
  {
    PrivateIntegrationsOpenAiPageRoute: PrivateIntegrationsOpenAiPageRoute,
    PrivateIntegrationsOpenAiPromptsPageRoute:
      PrivateIntegrationsOpenAiPromptsPageRoute,
    PrivateIntegrationsOpenAiPromptsIdPageRoute:
      PrivateIntegrationsOpenAiPromptsIdPageRoute,
  }

const PrivateIntegrationsOpenAiLayoutRouteWithChildren =
  PrivateIntegrationsOpenAiLayoutRoute._addFileChildren(
    PrivateIntegrationsOpenAiLayoutRouteChildren,
  )

interface PrivateIntegrationsPersonifyLayoutRouteChildren {
  PrivateIntegrationsPersonifyPageRoute: typeof PrivateIntegrationsPersonifyPageRoute
  PrivateIntegrationsPersonifyEventsPageRoute: typeof PrivateIntegrationsPersonifyEventsPageRoute
  PrivateIntegrationsPersonifyIdentitiesPageRoute: typeof PrivateIntegrationsPersonifyIdentitiesPageRoute
  PrivateIntegrationsPersonifyOverviewPageRoute: typeof PrivateIntegrationsPersonifyOverviewPageRoute
  PrivateIntegrationsPersonifyRewardsPageRoute: typeof PrivateIntegrationsPersonifyRewardsPageRoute
  PrivateIntegrationsPersonifyIdentitiesIdPageRoute: typeof PrivateIntegrationsPersonifyIdentitiesIdPageRoute
}

const PrivateIntegrationsPersonifyLayoutRouteChildren: PrivateIntegrationsPersonifyLayoutRouteChildren =
  {
    PrivateIntegrationsPersonifyPageRoute:
      PrivateIntegrationsPersonifyPageRoute,
    PrivateIntegrationsPersonifyEventsPageRoute:
      PrivateIntegrationsPersonifyEventsPageRoute,
    PrivateIntegrationsPersonifyIdentitiesPageRoute:
      PrivateIntegrationsPersonifyIdentitiesPageRoute,
    PrivateIntegrationsPersonifyOverviewPageRoute:
      PrivateIntegrationsPersonifyOverviewPageRoute,
    PrivateIntegrationsPersonifyRewardsPageRoute:
      PrivateIntegrationsPersonifyRewardsPageRoute,
    PrivateIntegrationsPersonifyIdentitiesIdPageRoute:
      PrivateIntegrationsPersonifyIdentitiesIdPageRoute,
  }

const PrivateIntegrationsPersonifyLayoutRouteWithChildren =
  PrivateIntegrationsPersonifyLayoutRoute._addFileChildren(
    PrivateIntegrationsPersonifyLayoutRouteChildren,
  )

interface PrivateIntegrationsLayoutRouteChildren {
  PrivateIntegrationsBayesiaLayoutRoute: typeof PrivateIntegrationsBayesiaLayoutRouteWithChildren
  PrivateIntegrationsOpenAiLayoutRoute: typeof PrivateIntegrationsOpenAiLayoutRouteWithChildren
  PrivateIntegrationsPersonifyLayoutRoute: typeof PrivateIntegrationsPersonifyLayoutRouteWithChildren
  PrivateIntegrationsPageRoute: typeof PrivateIntegrationsPageRoute
}

const PrivateIntegrationsLayoutRouteChildren: PrivateIntegrationsLayoutRouteChildren =
  {
    PrivateIntegrationsBayesiaLayoutRoute:
      PrivateIntegrationsBayesiaLayoutRouteWithChildren,
    PrivateIntegrationsOpenAiLayoutRoute:
      PrivateIntegrationsOpenAiLayoutRouteWithChildren,
    PrivateIntegrationsPersonifyLayoutRoute:
      PrivateIntegrationsPersonifyLayoutRouteWithChildren,
    PrivateIntegrationsPageRoute: PrivateIntegrationsPageRoute,
  }

const PrivateIntegrationsLayoutRouteWithChildren =
  PrivateIntegrationsLayoutRoute._addFileChildren(
    PrivateIntegrationsLayoutRouteChildren,
  )

interface PrivateNotificationAnalyticsLayoutRouteChildren {
  PrivateNotificationAnalyticsPageRoute: typeof PrivateNotificationAnalyticsPageRoute
  PrivateNotificationAnalyticsEmailTypePageRoute: typeof PrivateNotificationAnalyticsEmailTypePageRoute
}

const PrivateNotificationAnalyticsLayoutRouteChildren: PrivateNotificationAnalyticsLayoutRouteChildren =
  {
    PrivateNotificationAnalyticsPageRoute:
      PrivateNotificationAnalyticsPageRoute,
    PrivateNotificationAnalyticsEmailTypePageRoute:
      PrivateNotificationAnalyticsEmailTypePageRoute,
  }

const PrivateNotificationAnalyticsLayoutRouteWithChildren =
  PrivateNotificationAnalyticsLayoutRoute._addFileChildren(
    PrivateNotificationAnalyticsLayoutRouteChildren,
  )

interface PrivateProductsLayoutRouteChildren {
  PrivateProductsPageRoute: typeof PrivateProductsPageRoute
}

const PrivateProductsLayoutRouteChildren: PrivateProductsLayoutRouteChildren = {
  PrivateProductsPageRoute: PrivateProductsPageRoute,
}

const PrivateProductsLayoutRouteWithChildren =
  PrivateProductsLayoutRoute._addFileChildren(
    PrivateProductsLayoutRouteChildren,
  )

interface PrivateProfilesIdLayoutRouteChildren {
  PrivateProfilesIdPageRoute: typeof PrivateProfilesIdPageRoute
  PrivateProfilesIdCareplansPageRoute: typeof PrivateProfilesIdCareplansPageRoute
  PrivateProfilesIdDetailPageRoute: typeof PrivateProfilesIdDetailPageRoute
  PrivateProfilesIdEmailsPageRoute: typeof PrivateProfilesIdEmailsPageRoute
  PrivateProfilesIdMessagesPageRoute: typeof PrivateProfilesIdMessagesPageRoute
  PrivateProfilesIdSurveysPageRoute: typeof PrivateProfilesIdSurveysPageRoute
}

const PrivateProfilesIdLayoutRouteChildren: PrivateProfilesIdLayoutRouteChildren =
  {
    PrivateProfilesIdPageRoute: PrivateProfilesIdPageRoute,
    PrivateProfilesIdCareplansPageRoute: PrivateProfilesIdCareplansPageRoute,
    PrivateProfilesIdDetailPageRoute: PrivateProfilesIdDetailPageRoute,
    PrivateProfilesIdEmailsPageRoute: PrivateProfilesIdEmailsPageRoute,
    PrivateProfilesIdMessagesPageRoute: PrivateProfilesIdMessagesPageRoute,
    PrivateProfilesIdSurveysPageRoute: PrivateProfilesIdSurveysPageRoute,
  }

const PrivateProfilesIdLayoutRouteWithChildren =
  PrivateProfilesIdLayoutRoute._addFileChildren(
    PrivateProfilesIdLayoutRouteChildren,
  )

interface PrivateProfilesLayoutRouteChildren {
  PrivateProfilesIdLayoutRoute: typeof PrivateProfilesIdLayoutRouteWithChildren
  PrivateProfilesPageRoute: typeof PrivateProfilesPageRoute
}

const PrivateProfilesLayoutRouteChildren: PrivateProfilesLayoutRouteChildren = {
  PrivateProfilesIdLayoutRoute: PrivateProfilesIdLayoutRouteWithChildren,
  PrivateProfilesPageRoute: PrivateProfilesPageRoute,
}

const PrivateProfilesLayoutRouteWithChildren =
  PrivateProfilesLayoutRoute._addFileChildren(
    PrivateProfilesLayoutRouteChildren,
  )

interface PrivatePromisLayoutRouteChildren {
  PrivatePromisPageRoute: typeof PrivatePromisPageRoute
  PrivatePromisSymptomCodePageRoute: typeof PrivatePromisSymptomCodePageRoute
}

const PrivatePromisLayoutRouteChildren: PrivatePromisLayoutRouteChildren = {
  PrivatePromisPageRoute: PrivatePromisPageRoute,
  PrivatePromisSymptomCodePageRoute: PrivatePromisSymptomCodePageRoute,
}

const PrivatePromisLayoutRouteWithChildren =
  PrivatePromisLayoutRoute._addFileChildren(PrivatePromisLayoutRouteChildren)

interface PrivateLayoutRouteChildren {
  PrivateAdminsLayoutRoute: typeof PrivateAdminsLayoutRouteWithChildren
  PrivateIntegrationsLayoutRoute: typeof PrivateIntegrationsLayoutRouteWithChildren
  PrivateNotificationAnalyticsLayoutRoute: typeof PrivateNotificationAnalyticsLayoutRouteWithChildren
  PrivateProductsLayoutRoute: typeof PrivateProductsLayoutRouteWithChildren
  PrivateProfilesLayoutRoute: typeof PrivateProfilesLayoutRouteWithChildren
  PrivatePromisLayoutRoute: typeof PrivatePromisLayoutRouteWithChildren
  PrivateSplatRoute: typeof PrivateSplatRoute
  PrivatePageRoute: typeof PrivatePageRoute
}

const PrivateLayoutRouteChildren: PrivateLayoutRouteChildren = {
  PrivateAdminsLayoutRoute: PrivateAdminsLayoutRouteWithChildren,
  PrivateIntegrationsLayoutRoute: PrivateIntegrationsLayoutRouteWithChildren,
  PrivateNotificationAnalyticsLayoutRoute:
    PrivateNotificationAnalyticsLayoutRouteWithChildren,
  PrivateProductsLayoutRoute: PrivateProductsLayoutRouteWithChildren,
  PrivateProfilesLayoutRoute: PrivateProfilesLayoutRouteWithChildren,
  PrivatePromisLayoutRoute: PrivatePromisLayoutRouteWithChildren,
  PrivateSplatRoute: PrivateSplatRoute,
  PrivatePageRoute: PrivatePageRoute,
}

const PrivateLayoutRouteWithChildren = PrivateLayoutRoute._addFileChildren(
  PrivateLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  GuestLayoutRoute: GuestLayoutRouteWithChildren,
  PrivateLayoutRoute: PrivateLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
